import { ApplicationConfig, provideBrowserGlobalErrorListeners } from '@angular/core';
import { provideTranslateService } from '@ngx-translate/core';
import { provideTranslateHttpLoader } from '@ngx-translate/http-loader';
import { provideHttpClient } from '@angular/common/http';
import { provideRouter, withComponentInputBinding, withDebugTracing } from '@angular/router';
import { provideIndexedDb } from 'ngx-indexed-db';

import '@angular/common/locales/global/es';
import '@angular/common/locales/global/ca';
import '@angular/common/locales/global/en'

import { routes } from './app.routes';



export const appConfig: ApplicationConfig = {
  providers: [
    provideBrowserGlobalErrorListeners(), 
    provideRouter(routes, withComponentInputBinding(), /*withDebugTracing()*/),
    provideHttpClient(),
    provideTranslateService({
      loader: provideTranslateHttpLoader({
        prefix: '/assets/i18n/',
        suffix: '.json'
      }),
      fallbackLang:'ca',
      lang:'ca'
    }),
    provideIndexedDb({ // configuració de la BBDD (de moment només 'objects')
      name: '_previnapp_ia_db_', version: 3, objectStoresMeta: [], 
      migrationFactory: ()=>{
        return { 
          // Versió 1: crea un simple object-storage (key-value) amb la configuració per defecte
          1: (db: IDBDatabase, transaction: IDBTransaction)=>db.createObjectStore('objects'),
          // Versió 2: crea un object-storage per poder consultar les temporades dels productes
          2: (db:IDBDatabase, transaction: IDBTransaction)=>{
            const companies = db.createObjectStore('empreses', { keyPath: 'company_id', });
            companies.createIndex("name", "company_name", { unique: false });
          },
          3: (db:IDBDatabase, transaction: IDBTransaction)=>{
            // Main risk assessments store
            const assessments = db.createObjectStore("riskAssessments", {
              keyPath:['assessment_id', 'risk.risk_source_id'],
              autoIncrement: false
            });
            assessments.createIndex('byAssessment', 'assessment_id', { unique: false });
            assessments.createIndex('byRiskSource', 'risk.risk_source_id', { unique: false });
            assessments.createIndex('byCompany', 'company_id', { unique: false });
            // Thumbnails store
            const thumbnails = db.createObjectStore("riskThumbnails", {
              keyPath: 'thumbnail_id',
              autoIncrement: true
            });
            thumbnails.createIndex('byAsssessmentThumb', 'assessment_id', { unique:false });
            thumbnails.createIndex('byRiskSourceThumb', 'risk_source_id', { unique:false });
          }
        };
      },
    }),
  ],
};
